import React from 'react';
import classNames from 'classnames';
import { t } from '../../../../../i18n';
import { cameraIcon, clockIcon } from '../../../../assets';
import { formatCoursePrice } from '../../../../utilities';
import './styles.scss';

const CourseItem = ({ course, isSelected, onSelect, className }) => (
  <div
    className={classNames(
      'course-gift-item',
      !!onSelect && 'course-gift-item--selectable',
      isSelected && 'course-gift-item--selected',
      className,
    )}
    onClick={onSelect}
  >
    <div className="course-gift-item__author-info">
      <img className="course-gift-item__author-avatar" src={course.author.avatarImageUrl} alt="avatar" />
      <b title={course.author.fullName}>{course.author.fullName}</b>
    </div>
    <div className="course-gift-item__thumbnail">
      <picture>
        <source media="(min-width: 1000px)" srcSet={course.previewImageUrlLarge} />
        <img src={course.previewImageUrlSmall} alt={course.title} className="course-gift-item__thumbnail-image" />
      </picture>
    </div>
    <div className="course-gift-item__description">
      <b>{course.title}</b>
    </div>
    <div className="course-gift-item__summary">
      <div className="course-gift-item__course-hours">
        <img src={clockIcon} alt="hours" />
        <span className="course-gift-item__course-hours-text course-gift-item__course-hours-text--full">{`${
          course.hoursTotal
        } ${t('DIGITAL_COURSES.HOURS')}`}</span>
        <span className="course-gift-item__course-hours-text course-gift-item__course-hours-text--short">{`${
          course.hoursTotal
        }${t('DIGITAL_COURSES.HOURS_SHORT')}`}</span>
      </div>
      {course.lessonsTotal > 1 && (
        <div className="course-gift-item__course-lessons-number">
          <img src={cameraIcon} alt="lessons-number" />
          {`${course.lessonsTotal} ${t('DIGITAL_COURSES.LESSONS')}`}
        </div>
      )}
      <div className="course-gift-item__course-price">
        <span className="course-gift-item__course-price-text course-gift-item__course-price-text--new">
          {formatCoursePrice({ amount: 0, currency: course.price.currency })}
        </span>
        <span className="course-gift-item__course-price-text course-gift-item__course-price-text--old">
          {formatCoursePrice(course.price)}
        </span>
      </div>
    </div>
  </div>
);

CourseItem.Placeholder = ({ className }) => (
  <div className={classNames('course-gift-item__placeholder', 'placeholder-glow', className)}>
    <div className="placeholder" />
  </div>
);

export default CourseItem;
